import React, { Component } from 'react';
import type { Store } from 'redux';
import AppBase from '@atlassian/jira-app-base';
import AppStyle from '@atlassian/jira-common-components-app-style';
import { ErrorBoundary } from '@atlassian/jira-error-boundary';
import { store } from '@atlassian/jira-flags/src/services/store';
import { reset } from '@atlassian/jira-flags/src/services/store/constants';
import type { State } from '@atlassian/jira-flags/src/services/store/types';
import View from './view';

type Props = {
	store?: Store<State>;
};

let counter = 0;

// eslint-disable-next-line jira/react/no-class-components
export default class Flags extends Component<Props> {
	constructor(props: Props) {
		super(props);
		this.store = props.store ?? store;
	}

	componentDidMount() {
		counter += 1;
		if (counter > 1) {
			throw new Error('Invalid state: Two flag applications mounted at the same time.');
		}
	}

	componentWillUnmount() {
		counter -= 1;
		this.store.dispatch(reset());
	}

	store: Store<State>;

	render() {
		return (
			<ErrorBoundary>
				<AppBase store={this.store}>
					<AppStyle>
						<View />
					</AppStyle>
				</AppBase>
			</ErrorBoundary>
		);
	}
}
